/* eslint-disable @typescript-eslint/no-explicit-any */ import { createRecordType, defineMigrations } from "@supersig/store";
import { T } from "@supersig/validate";
import { mapObjectMapValues } from "../../utils";
import { createLocalizationProviderInfoValidator } from "../localizationProviders/SWBaseLocalizationProviderInfo";
/** @internal */ export const rootLocalizationProviderInfoVersions = {};
/** @internal */ export const rootLocalizationProviderInfoMigrations = defineMigrations({});
/** @public */ export function isLocalizationProviderInfo(record) {
    if (!record) return false;
    return record.typeName === "localization_provider_info";
}
/** @public */ export function isLocalizationProviderInfoId(id) {
    if (!id) return false;
    return id.startsWith("localization_provider_info:");
}
/** @public */ export function createLocalizationProviderInfoId({ type, projectIdentifier, organizationId }) {
    return `localization_provider_info:${[
        type,
        organizationId,
        projectIdentifier
    ].join(":")}`;
}
/** @public */ export function parseLocalizationProviderInfoId(id) {
    if (!id) return undefined;
    if (!id.startsWith("localization_provider_info:")) return undefined;
    // Split into many pieces
    const parts = id.replace("localization_provider_info:", "").split(":");
    const type = parts.shift();
    const organizationId = parseInt(parts.shift() || "");
    const projectIdentifier = parts.join(":");
    if (isNaN(organizationId)) return undefined;
    return {
        type: type,
        organizationId,
        projectIdentifier: projectIdentifier
    };
}
/** @internal */ export function createLocalizationProviderInfoRecordType(localization_provider_infos) {
    return createRecordType("localization_provider_info", {
        migrations: defineMigrations({
            subTypeKey: "type",
            subTypeMigrations: mapObjectMapValues(localization_provider_infos, (_, v)=>{
                var _v_migrations;
                return (_v_migrations = v.migrations) !== null && _v_migrations !== void 0 ? _v_migrations : defineMigrations({});
            })
        }),
        scope: "presence",
        validator: T.model("localization_provider_info", T.union("type", mapObjectMapValues(localization_provider_infos, (type, { props, meta })=>createLocalizationProviderInfoValidator(type, props, meta))))
    }).withDefaultProperties(()=>({
            meta: {},
            internalLocalizationProviderInfoId: 0,
            visibilitySince: 0
        }));
}
